import styled, { css } from 'styled-components';

export const AccordionWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.km4} 0;
  `}
`;

export const HeaderWrapper = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  height: 26px;

  ${({ theme, isOpen }) =>
    isOpen &&
    css`
      margin-bottom: ${theme.spacing.km2};
    `}
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-flow: wrap;
    gap: ${theme.spacing.km4} ${theme.spacing.km4};
    height: min-content;
    margin-top: ${theme.spacing.km4};
  `}
`;

export const ChevronWrapper = styled.span<{ isOpen: boolean }>`
  display: flex;
  align-items: center;

  ${({ isOpen }) =>
    isOpen &&
    css`
      transition: transform 0.3s ease;
      transform: rotate(180deg);
    `}
`;
